import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type AlertsState } from '../types';

type DismissAlertPayload = {
  scope: string;
  id: string;
  registeredBy?: string;
};

const dismissAlertCase: CaseReducer<
  AlertsState,
  PayloadAction<DismissAlertPayload>
> = (state, action) => {
  state.items = state.items.filter(item => {
    const isSameEntry =
      item.scope === action.payload.scope && item.id === action.payload.id;

    if (!isSameEntry) return true;

    if (action.payload.registeredBy === undefined) return false;

    return item.registeredBy !== action.payload.registeredBy;
  });

  return state;
};

export { dismissAlertCase };
export type { DismissAlertPayload };
